var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { useContext } from "react";
import { RicosContext, RicosViewerContext } from "./../../ricos-context";
import { IMAGE_TYPE } from "../types";
import { alignmentClassName, sizeClassName, textWrapClassName } from "./class-name-strategies";
import { getExpandFunction } from "./get-expand-function";
import { getImageClickActionConfig } from "./get-image-click-action-config";
import { Image } from "./image";
import { ViewerImageCaption } from "./viewer-image-caption";
const ViewerImage = ({ node, nodeIndex, NodeViewContainer }) => {
  var _a, _b;
  const { config: viewerConfig, seoMode, helpers } = useContext(RicosViewerContext);
  const { isMobile, t } = useContext(RicosContext);
  const config = (_a = viewerConfig[IMAGE_TYPE]) != null ? _a : {};
  const expand = getExpandFunction({
    helpers,
    config,
    nodeId: node.id,
    imageData: node.imageData
  });
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: node.imageData,
    config,
    expand
  });
  return /* @__PURE__ */ React.createElement(
    NodeViewContainer,
    {
      node,
      nodeIndex,
      customClassNames: {
        alignment: alignmentClassName(node),
        size: sizeClassName(node, isMobile),
        textWrap: textWrapClassName(node)
      }
    },
    /* @__PURE__ */ React.createElement(
      Image,
      {
        node,
        imageClickActionConfig,
        expand,
        config,
        seoMode,
        helpers,
        isMobile,
        shouldLazyLoadImages: true,
        captionComponent: /* @__PURE__ */ React.createElement(
          ViewerImageCaption,
          {
            imageType: imageClickActionConfig.type,
            caption: (_b = node == null ? void 0 : node.imageData) == null ? void 0 : _b.caption,
            defaultCaption: t("ImageViewer_Caption")
          }
        )
      }
    )
  );
};
const ImageRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(ViewerImage, __spreadValues({ key: node.id, node }, props));
};
var viewer_image_default = ImageRenderer;
export {
  viewer_image_default as default
};
//# sourceMappingURL=viewer-image.js.map
